/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import ContactUsImg from "../../Assets/contactusimage-new.jpg";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { useSelector } from "react-redux";
import VtigerContactForm from "../../Components/VtigerContactForm/VtigerContactForm";
import '../../Assets/css/contact_vtiger.css';
import { trackEvent } from "../../Components/Utility/Utility";

const ContactUs = () => {
  const translation = getTranslationData();
  const [contactHtml, setContactHtml] = useState("");
  const clientinfo = useSelector((state) => state.clientDataReducer);
  const containerRef = useRef(null);
  const formDomRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const loadContactUsHtml = async () => {
    const response = await fetch(
      `/contactUsForm/${clientinfo.clientCode}/contactus.html`
    );
    const html = await response.text();
    if (
      html.includes('<div id="root">') ||
      html.includes("static/js/bundle.js")
    ) {
      return null;
    }
    return html;
  };

  useEffect(() => {
    const fetchHtml = async () => {

      // Check if already reloaded in this session
      // const contactUsReloaded = localStorage.getItem('contactUs_reloaded');
      // const isLoggedIn = sessionStorage.getItem('login') === 'true';

      // if (!contactUsReloaded && isLoggedIn) {
      //   debugger
      //   localStorage.setItem('contactUs_reloaded', 'true');
      //   window.location.reload();
      //   return;
      // }
      setLoading(true);
      try {
        const htmlString = await loadContactUsHtml();
        if (htmlString) {
          setContactHtml(htmlString);
        } else {
          setContactHtml("");
        }
      } catch (err) {
        console.error("Failed to load contact HTML", err);
      }
    };

    fetchHtml();

    trackEvent("page_browse", {
      page_title: "contact us",
      page_url: window.location.href,
    });

  }, []);

  // Run scripts after HTML is injected
  useEffect(() => {
    const container = containerRef.current;
    if (!container || !contactHtml) {
      setLoading(false);
      return;
    }

    const scripts = container.querySelectorAll("script");
    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach(attr =>
        newScript.setAttribute(attr.name, attr.value)
      );
      newScript.innerHTML = oldScript.innerHTML;
      oldScript.parentNode.replaceChild(newScript, oldScript);
      setLoading(false);
    });

    if (window.initContactForm) {
      window.initContactForm();
    }

  }, [contactHtml]);

  return (
    <>
      {!loading &&

        <section className="contact_us_page">
          <ScrollToTop />
          <div className="py-0 py-md-4">
            {/* Banner Section */}
            <div className="row justify-content-center mb-4">
              <div className="col-md-8">
                <div className="d-flex justify-content-center position-relative">
                  <h2 className="contact_banner_text">
                    {translation?.howCanWe} <br /> {translation?.helpYouToday}
                  </h2>
                  <img
                    src={ContactUsImg}
                    alt="banner"
                    className="contact_us_banner"
                  />
                </div>
              </div>
            </div>

            {/* Form Section */}
            <div className={`row container justify-content-center  ${contactHtml ? "contact_us_form_box" : ""}`}>
              <div className="col-md-5 ">
                <div className={`${contactHtml ? "contact_form_container" : ""}`}>
                  <div ref={containerRef} dangerouslySetInnerHTML={{ __html: contactHtml }} />
                </div>
                <div className="contact_form_text d-flex justify-content-center align-items-center mt-5">
                  {/* <div className="contact_no_icon">
                    <i className="las la-phone-alt"></i>
                  </div> */}
                  <div className="contact_no_text">
                    {/* <p className="mb-0">{translation?.ReachUsAT}</p> */}
                    <p className="mb-0">{translation?.contactus_number}
                      <small>{translation?.contact_available}</small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }
    </>
  );
};

export default ContactUs;